import { navigate } from 'gatsby';
import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import LogoPagarme from '../../images/Header/pagarme-logo-main.svg';

import BurguerMenu from '../BurguerMenuu';
import Responsive from '../Responsive';

import { Link } from '../Link';

import { BlogMenu } from './BlogMenu';
import { SiteMenu } from './SiteMenu';

import * as S from './styles';

import { factoryAnalyticsEvents } from '../../hooks/useAnalyticsEvent';
import LazyImage from '../LazyLoadImage';
const { sendEvent } = factoryAnalyticsEvents();

const clickLogin = () => {
  sendEvent({
    label: '',
    entity: 'page',
    name: 'cta pagarme',
    description: 'Evento disparado quando o usuário clicar no link "Entrar" no cabeçalho de home',
    deduplicate: false,
    section_reference: 'Header',
    cta_reference: 'Entrar',
  });
};

const LoginButton = ({ marginRight }) => (
  <S.Login $marginRight={marginRight} to="https://id.pagar.me" onClick={clickLogin}>
    Entrar
  </S.Login>
);

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasScrolled: false,
      pathname: '',
      isSolutionPage: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);

    this.setState({ pathname: window.location.pathname });
    this.checkSolutionActive();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  checkSolutionActive = () => {
    if (typeof window !== 'undefined') {
      const solutionsPages = ['/pronto-para-usar', '/integre-com-nossos-produtos', '/sobre'];

      if (solutionsPages.includes(window.location.pathname)) {
        this.setState({ isSolutionPage: true });
      }
    }
  };

  handleScroll = () => {
    const oldHasScrolled = this.state.hasScrolled;
    const newHasScrolled = window.scrollY !== 0; // recebeu scroll nessa parte

    if (oldHasScrolled !== newHasScrolled) this.setState({ hasScrolled: !oldHasScrolled });
  };

  getNewsletterButton = () => {
    const { pathname } = this.state;
    const isBlog = pathname === '/blog';

    const navigateNewsLetter = () =>
      navigate('/newsletter', {
        state: {
          rootUri: window.location.pathname,
        },
      });

    if (isBlog) {
      return (
        <AnchorLink className="button" offset="150" href="#newsletter-section">
          Inscreva-se
        </AnchorLink>
      );
    }

    return (
      <button className="button" onClick={navigateNewsLetter}>
        Inscreva-se
      </button>
    );
  };

  getCtaUsar = () => {
    const { pathname } = this.state;
    const pricePageRegex = /^.*\/ofertas.*$/;
    const atPricePage = pricePageRegex.test(pathname);

    if (atPricePage) {
      return <LoginButton />;
    }

    const clickRegisterNow = () => {
      sendEvent({
        label: '',
        entity: 'page',
        name: 'cta pagarme',
        description: 'Evento disparado quando o usuário clicar no botão "Seja pagar.me" no cabeçalho da home',
        deduplicate: false,
        section_reference: 'Header',
        cta_reference: 'Seja Pagar.me',
      });
    };

    return (
      <>
        <Responsive max={767}>
          <LoginButton />
        </Responsive>
        <Responsive min={767}>
          <LoginButton marginRight />
          <Link className="button" to="/ofertas" absolute onClick={clickRegisterNow}>
            Seja Pagar.me
          </Link>
        </Responsive>
      </>
    );
  };

  render() {
    const { blog } = this.props;
    const { hasScrolled } = this.state;
    const logoRedirect = blog ? '/blog' : '/';

    return (
      <S.HeaderWrapper blog={blog} hasScrolled={hasScrolled}>
        <BurguerMenu blog={blog} />
        <S.MainHeader>
          <S.Container blog={blog}>
            <Link to={logoRedirect} className="mobile-logo">
              <LazyImage data-aos="fade-up" src={LogoPagarme} alt="Logo da Pagar.me" />
            </Link>
            <Link to={logoRedirect} className="logo">
              <LazyImage src={LogoPagarme} alt="Logo da Pagar.me" />
            </Link>
            <S.NavBar>
              {blog ? <BlogMenu /> : <SiteMenu />}

              <S.CTAContainer>{blog ? this.getNewsletterButton() : this.getCtaUsar()}</S.CTAContainer>
            </S.NavBar>
          </S.Container>
        </S.MainHeader>
      </S.HeaderWrapper>
    );
  }
}

export default Header;
